import { render, staticRenderFns } from "./anniversary-active-sign-table.vue?vue&type=template&id=133713c2&"
import script from "./anniversary-active-sign-table.vue?vue&type=script&lang=js&"
export * from "./anniversary-active-sign-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports